import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownToBracket } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const ExportCSVMenuItem = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <DropdownMenuItem onClick={onClick} disabled={disabled}>
      <FontAwesomeIcon icon={faArrowDownToBracket} size="lg" />
      <MenuItemLabel>Export CSV</MenuItemLabel>
    </DropdownMenuItem>
  );
};
